import { GraphQLClient } from "graphql-request";
import * as Dom from "graphql-request/dist/types.dom";
import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Asset = {
  __typename?: "Asset";
  assetId: Scalars["String"];
  assetName: Scalars["String"];
  decimals: Scalars["Int"];
  logo: Scalars["String"];
  mintDate: DateTime;
  policyId: Scalars["String"];
  ticker: Scalars["String"];
  totalSupply: Scalars["String"];
};

export type DateTime = {
  __typename?: "DateTime";
  format: Scalars["String"];
  slot: Scalars["String"];
};

export type DateTimeFormatArgs = {
  layout?: InputMaybe<Scalars["String"]>;
};

export type Fraction = {
  __typename?: "Fraction";
  denominator: Scalars["Int"];
  numerator: Scalars["Int"];
};

export type HistoricalBalance = {
  __typename?: "HistoricalBalance";
  times: Array<Scalars["String"]>;
  tokenGathered: Array<Scalars["String"]>;
};

export type Milestone = {
  __typename?: "Milestone";
  accomplished: Scalars["Boolean"];
  description: Scalars["String"];
  dueDate: DateTime;
  title: Scalars["String"];
};

export type Mutation = {
  __typename?: "Mutation";
  reserveForDeposit: Node;
  reserveForUpdate: Node;
  reserveForWithdrawal: Array<Node>;
};

export type MutationReserveForDepositArgs = {
  owner: Scalars["String"];
  tasteTest: Scalars["String"];
};

export type MutationReserveForUpdateArgs = {
  owner: Scalars["String"];
  tasteTest: Scalars["String"];
};

export type MutationReserveForWithdrawalArgs = {
  owner: Scalars["String"];
  tasteTest: Scalars["String"];
};

export type Node = {
  __typename?: "Node";
  datumHex: Scalars["String"];
  deposit: Scalars["String"];
  foldFee: Scalars["String"];
  index: Scalars["Int"];
  minUTXO: Scalars["String"];
  next: Scalars["String"];
  owner: Scalars["String"];
  spentTxHash: Scalars["String"];
  txHash: Scalars["String"];
};

export type Partner = {
  __typename?: "Partner";
  logo: Scalars["String"];
  name: Scalars["String"];
  type: Scalars["String"];
  url: Scalars["String"];
};

export type PieSlice = {
  __typename?: "PieSlice";
  label: Scalars["String"];
  percentage: Scalars["Float"];
};

export type ProjectDetails = {
  __typename?: "ProjectDetails";
  description: Scalars["String"];
  handle?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  partners: Array<Partner>;
  roadmap: Array<Milestone>;
  socials: Array<Social>;
  team: Team;
  tokenomics: Array<PieSlice>;
};

export type Query = {
  __typename?: "Query";
  current: Array<Transaction>;
  history: Array<Transaction>;
  now: DateTime;
  ok: Scalars["String"];
  tasteTest: TasteTest;
  tasteTestBySlug: TasteTest;
  tasteTests: Array<TasteTest>;
};

export type QueryCurrentArgs = {
  owner: Scalars["String"];
  tasteTest?: InputMaybe<Scalars["String"]>;
};

export type QueryHistoryArgs = {
  owner: Scalars["String"];
  tasteTest?: InputMaybe<Scalars["String"]>;
};

export type QueryTasteTestArgs = {
  policyID: Scalars["String"];
};

export type QueryTasteTestBySlugArgs = {
  slug: Scalars["String"];
};

export type ReferenceScript = {
  __typename?: "ReferenceScript";
  scriptBytes: Scalars["String"];
  scriptHash: Scalars["String"];
  utxo?: Maybe<TxOutRef>;
};

export type Social = {
  __typename?: "Social";
  name: SocialType;
  url: Scalars["String"];
};

export enum SocialType {
  Discord = "Discord",
  Github = "Github",
  LinkedIn = "LinkedIn",
  Medium = "Medium",
  Other = "Other",
  Reddit = "Reddit",
  Telegram = "Telegram",
  Twitter = "Twitter",
  Website = "Website",
  Whitepaper = "Whitepaper",
  Youtube = "Youtube",
}

export enum Status {
  Closing = "Closing",
  Concluded = "Concluded",
  Draft = "Draft",
  Geofenced = "Geofenced",
  LastCall = "LastCall",
  Moderated = "Moderated",
  Ongoing = "Ongoing",
  Pending = "Pending",
}

export type TasteTest = {
  __typename?: "TasteTest";
  adaHandle: Scalars["String"];
  asset: Asset;
  banner?: Maybe<Scalars["String"]>;
  banners: Array<Scalars["String"]>;
  changeTVL24h: Scalars["Float"];
  createdDate: DateTime;
  creationTxHash: Scalars["String"];
  currentBalance: TokenStats;
  endDate: DateTime;
  fundingAllocations: Array<PieSlice>;
  historicalBalance: HistoricalBalance;
  interactions: Scalars["Int"];
  lastCallDate: DateTime;
  openDate: DateTime;
  parameters: TasteTestParameters;
  participants: Scalars["Int"];
  policyId: Scalars["String"];
  primaryColor?: Maybe<Scalars["String"]>;
  profile?: Maybe<Scalars["String"]>;
  projectDetails: ProjectDetails;
  scripts: TasteTestScripts;
  secondaryColor?: Maybe<Scalars["String"]>;
  slug: Scalars["String"];
  status: Status;
  transactions: Array<Transaction>;
  type: TasteTestType;
  userContribution: Transaction;
  userContributionHistory: Array<Transaction>;
  vestingSchedule: Array<VestingParty>;
};

export type TasteTestUserContributionArgs = {
  owner: Scalars["String"];
};

export type TasteTestUserContributionHistoryArgs = {
  owner: Scalars["String"];
};

export type TasteTestParameters = {
  __typename?: "TasteTestParameters";
  beneficiaryAddress: Scalars["String"];
  foldFee: Scalars["Int"];
  minUTXO: Scalars["Int"];
  penaltyAddress: Scalars["String"];
  penaltyPercentage: Scalars["Float"];
  poolFee: Fraction;
  poolPolicyId: Scalars["String"];
};

export type TasteTestScripts = {
  __typename?: "TasteTestScripts";
  collectFoldPolicy: ReferenceScript;
  collectFoldValidator: ReferenceScript;
  rewardFoldPolicy: ReferenceScript;
  rewardFoldValidator: ReferenceScript;
  tasteTestPolicy: ReferenceScript;
  tasteTestStakeValidator: ReferenceScript;
  tasteTestValidator: ReferenceScript;
  tokenHolderPolicy: ReferenceScript;
  tokenHolderValidator: ReferenceScript;
};

export enum TasteTestType {
  Direct = "Direct",
  Liquidity = "Liquidity",
}

export type Team = {
  __typename?: "Team";
  company: Scalars["String"];
  members: Array<TeamMember>;
  other: Array<Scalars["String"]>;
  socials: Array<Social>;
};

export type TeamMember = {
  __typename?: "TeamMember";
  name: Scalars["String"];
  role: Scalars["String"];
  social?: Maybe<Social>;
};

export type TokenAmount = {
  __typename?: "TokenAmount";
  amount: Scalars["String"];
  asset: Asset;
};

export type TokenStats = {
  __typename?: "TokenStats";
  timestamp: DateTime;
  tokenGathered: TokenAmount;
  tokenSupplied: TokenAmount;
};

export type Transaction = {
  __typename?: "Transaction";
  createdAt: DateTime;
  depositCumulative: Array<TokenAmount>;
  depositDelta: Array<TokenAmount>;
  foldFeeCumulative: Array<TokenAmount>;
  foldFeeDelta: Array<TokenAmount>;
  lpCumulative: Array<TokenAmount>;
  lpDelta: Array<TokenAmount>;
  minUTXOCumulative: Array<TokenAmount>;
  minUTXODelta: Array<TokenAmount>;
  owner: Scalars["String"];
  tasteTest: TasteTest;
  totalCumulative: Array<TokenAmount>;
  totalDelta: Array<TokenAmount>;
  txHash: Scalars["String"];
  type: TransactionType;
};

export enum TransactionType {
  Claim = "Claim",
  Collect = "Collect",
  Deposit = "Deposit",
  Distribute = "Distribute",
  Initialize = "Initialize",
  Placeholder = "Placeholder",
  Unknown = "Unknown",
  Update = "Update",
  Withdraw = "Withdraw",
}

export type TxOutRef = {
  __typename?: "TxOutRef";
  index: Scalars["Int"];
  txHash: Scalars["String"];
};

export type VestingParty = {
  __typename?: "VestingParty";
  address: Scalars["String"];
  amount: Scalars["String"];
  label: Scalars["String"];
  releaseDate: DateTime;
};

export type AssetFragment = {
  __typename?: "Asset";
  assetId: string;
  policyId: string;
  assetName: string;
  ticker: string;
  totalSupply: string;
  decimals: number;
  logo: string;
  mintDate: { __typename?: "DateTime"; format: string };
};

export type ReferenceScriptFragment = {
  __typename?: "ReferenceScript";
  scriptHash: string;
  utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
};

export type TasteTestFragmentFragment = {
  __typename?: "TasteTest";
  policyId: string;
  creationTxHash: string;
  status: Status;
  slug: string;
  profile?: string | null;
  primaryColor?: string | null;
  secondaryColor?: string | null;
  banner?: string | null;
  banners: Array<string>;
  adaHandle: string;
  changeTVL24h: number;
  interactions: number;
  participants: number;
  asset: {
    __typename?: "Asset";
    assetId: string;
    policyId: string;
    assetName: string;
    ticker: string;
    totalSupply: string;
    decimals: number;
    logo: string;
    mintDate: { __typename?: "DateTime"; format: string };
  };
  parameters: {
    __typename?: "TasteTestParameters";
    penaltyAddress: string;
    foldFee: number;
    minUTXO: number;
    penaltyPercentage: number;
    poolPolicyId: string;
  };
  scripts: {
    __typename?: "TasteTestScripts";
    tasteTestPolicy: {
      __typename?: "ReferenceScript";
      scriptHash: string;
      utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
    };
    tasteTestValidator: {
      __typename?: "ReferenceScript";
      scriptHash: string;
      utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
    };
    tasteTestStakeValidator: {
      __typename?: "ReferenceScript";
      scriptHash: string;
      utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
    };
    collectFoldPolicy: {
      __typename?: "ReferenceScript";
      scriptHash: string;
      utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
    };
    collectFoldValidator: {
      __typename?: "ReferenceScript";
      scriptHash: string;
      utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
    };
    rewardFoldPolicy: {
      __typename?: "ReferenceScript";
      scriptHash: string;
      utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
    };
    rewardFoldValidator: {
      __typename?: "ReferenceScript";
      scriptHash: string;
      utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
    };
    tokenHolderPolicy: {
      __typename?: "ReferenceScript";
      scriptHash: string;
      utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
    };
    tokenHolderValidator: {
      __typename?: "ReferenceScript";
      scriptHash: string;
      utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
    };
  };
  createdDate: { __typename?: "DateTime"; format: string };
  openDate: { __typename?: "DateTime"; format: string };
  lastCallDate: { __typename?: "DateTime"; format: string };
  endDate: { __typename?: "DateTime"; format: string; slot: string };
  currentBalance: {
    __typename?: "TokenStats";
    timestamp: { __typename?: "DateTime"; format: string };
    tokenSupplied: {
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    };
    tokenGathered: {
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    };
  };
  historicalBalance: {
    __typename?: "HistoricalBalance";
    times: Array<string>;
    tokenGathered: Array<string>;
  };
  projectDetails: {
    __typename?: "ProjectDetails";
    name: string;
    handle?: string | null;
    description: string;
    team: {
      __typename?: "Team";
      company: string;
      other: Array<string>;
      members: Array<{
        __typename?: "TeamMember";
        name: string;
        role: string;
        social?: { __typename?: "Social"; name: SocialType; url: string } | null;
      }>;
      socials: Array<{ __typename?: "Social"; name: SocialType; url: string }>;
    };
    socials: Array<{ __typename?: "Social"; name: SocialType; url: string }>;
    tokenomics: Array<{ __typename?: "PieSlice"; label: string; percentage: number }>;
    roadmap: Array<{
      __typename?: "Milestone";
      title: string;
      description: string;
      accomplished: boolean;
      dueDate: { __typename?: "DateTime"; format: string };
    }>;
    partners: Array<{
      __typename?: "Partner";
      logo: string;
      url: string;
      name: string;
      type: string;
    }>;
  };
  vestingSchedule: Array<{
    __typename?: "VestingParty";
    address: string;
    amount: string;
    label: string;
    releaseDate: { __typename?: "DateTime"; format: string };
  }>;
  fundingAllocations: Array<{ __typename?: "PieSlice"; label: string; percentage: number }>;
};

export type TransactionFragment = {
  __typename?: "Transaction";
  txHash: string;
  type: TransactionType;
  owner: string;
  createdAt: { __typename?: "DateTime"; format: string };
  totalCumulative: Array<{
    __typename?: "TokenAmount";
    amount: string;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
  }>;
  totalDelta: Array<{
    __typename?: "TokenAmount";
    amount: string;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
  }>;
  depositDelta: Array<{
    __typename?: "TokenAmount";
    amount: string;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
  }>;
  foldFeeDelta: Array<{
    __typename?: "TokenAmount";
    amount: string;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
  }>;
  lpDelta: Array<{
    __typename?: "TokenAmount";
    amount: string;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
  }>;
  minUTXODelta: Array<{
    __typename?: "TokenAmount";
    amount: string;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
  }>;
  depositCumulative: Array<{
    __typename?: "TokenAmount";
    amount: string;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
  }>;
  foldFeeCumulative: Array<{
    __typename?: "TokenAmount";
    amount: string;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
  }>;
  lpCumulative: Array<{
    __typename?: "TokenAmount";
    amount: string;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
  }>;
  minUTXOCumulative: Array<{
    __typename?: "TokenAmount";
    amount: string;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
  }>;
};

export type GetTasteTestsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTasteTestsQuery = {
  __typename?: "Query";
  tasteTests: Array<{
    __typename?: "TasteTest";
    policyId: string;
    creationTxHash: string;
    status: Status;
    slug: string;
    profile?: string | null;
    primaryColor?: string | null;
    secondaryColor?: string | null;
    banner?: string | null;
    banners: Array<string>;
    adaHandle: string;
    changeTVL24h: number;
    interactions: number;
    participants: number;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
    parameters: {
      __typename?: "TasteTestParameters";
      penaltyAddress: string;
      foldFee: number;
      minUTXO: number;
      penaltyPercentage: number;
      poolPolicyId: string;
    };
    scripts: {
      __typename?: "TasteTestScripts";
      tasteTestPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tasteTestValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tasteTestStakeValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      collectFoldPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      collectFoldValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      rewardFoldPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      rewardFoldValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tokenHolderPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tokenHolderValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
    };
    createdDate: { __typename?: "DateTime"; format: string };
    openDate: { __typename?: "DateTime"; format: string };
    lastCallDate: { __typename?: "DateTime"; format: string };
    endDate: { __typename?: "DateTime"; format: string; slot: string };
    currentBalance: {
      __typename?: "TokenStats";
      timestamp: { __typename?: "DateTime"; format: string };
      tokenSupplied: {
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      };
      tokenGathered: {
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      };
    };
    historicalBalance: {
      __typename?: "HistoricalBalance";
      times: Array<string>;
      tokenGathered: Array<string>;
    };
    projectDetails: {
      __typename?: "ProjectDetails";
      name: string;
      handle?: string | null;
      description: string;
      team: {
        __typename?: "Team";
        company: string;
        other: Array<string>;
        members: Array<{
          __typename?: "TeamMember";
          name: string;
          role: string;
          social?: { __typename?: "Social"; name: SocialType; url: string } | null;
        }>;
        socials: Array<{ __typename?: "Social"; name: SocialType; url: string }>;
      };
      socials: Array<{ __typename?: "Social"; name: SocialType; url: string }>;
      tokenomics: Array<{ __typename?: "PieSlice"; label: string; percentage: number }>;
      roadmap: Array<{
        __typename?: "Milestone";
        title: string;
        description: string;
        accomplished: boolean;
        dueDate: { __typename?: "DateTime"; format: string };
      }>;
      partners: Array<{
        __typename?: "Partner";
        logo: string;
        url: string;
        name: string;
        type: string;
      }>;
    };
    vestingSchedule: Array<{
      __typename?: "VestingParty";
      address: string;
      amount: string;
      label: string;
      releaseDate: { __typename?: "DateTime"; format: string };
    }>;
    fundingAllocations: Array<{ __typename?: "PieSlice"; label: string; percentage: number }>;
  }>;
};

export type GetTasteTestByPolicyIdQueryVariables = Exact<{
  policyID: Scalars["String"];
}>;

export type GetTasteTestByPolicyIdQuery = {
  __typename?: "Query";
  tasteTest: {
    __typename?: "TasteTest";
    type: TasteTestType;
    policyId: string;
    creationTxHash: string;
    status: Status;
    slug: string;
    profile?: string | null;
    primaryColor?: string | null;
    secondaryColor?: string | null;
    banner?: string | null;
    banners: Array<string>;
    adaHandle: string;
    changeTVL24h: number;
    interactions: number;
    participants: number;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
    parameters: {
      __typename?: "TasteTestParameters";
      penaltyAddress: string;
      foldFee: number;
      minUTXO: number;
      penaltyPercentage: number;
      poolPolicyId: string;
    };
    scripts: {
      __typename?: "TasteTestScripts";
      tasteTestPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tasteTestValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tasteTestStakeValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      collectFoldPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      collectFoldValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      rewardFoldPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      rewardFoldValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tokenHolderPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tokenHolderValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
    };
    createdDate: { __typename?: "DateTime"; format: string };
    openDate: { __typename?: "DateTime"; format: string };
    lastCallDate: { __typename?: "DateTime"; format: string };
    endDate: { __typename?: "DateTime"; format: string; slot: string };
    currentBalance: {
      __typename?: "TokenStats";
      timestamp: { __typename?: "DateTime"; format: string };
      tokenSupplied: {
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      };
      tokenGathered: {
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      };
    };
    historicalBalance: {
      __typename?: "HistoricalBalance";
      times: Array<string>;
      tokenGathered: Array<string>;
    };
    projectDetails: {
      __typename?: "ProjectDetails";
      name: string;
      handle?: string | null;
      description: string;
      team: {
        __typename?: "Team";
        company: string;
        other: Array<string>;
        members: Array<{
          __typename?: "TeamMember";
          name: string;
          role: string;
          social?: { __typename?: "Social"; name: SocialType; url: string } | null;
        }>;
        socials: Array<{ __typename?: "Social"; name: SocialType; url: string }>;
      };
      socials: Array<{ __typename?: "Social"; name: SocialType; url: string }>;
      tokenomics: Array<{ __typename?: "PieSlice"; label: string; percentage: number }>;
      roadmap: Array<{
        __typename?: "Milestone";
        title: string;
        description: string;
        accomplished: boolean;
        dueDate: { __typename?: "DateTime"; format: string };
      }>;
      partners: Array<{
        __typename?: "Partner";
        logo: string;
        url: string;
        name: string;
        type: string;
      }>;
    };
    vestingSchedule: Array<{
      __typename?: "VestingParty";
      address: string;
      amount: string;
      label: string;
      releaseDate: { __typename?: "DateTime"; format: string };
    }>;
    fundingAllocations: Array<{ __typename?: "PieSlice"; label: string; percentage: number }>;
  };
};

export type GetTasteTestBySlugQueryVariables = Exact<{
  slug: Scalars["String"];
}>;

export type GetTasteTestBySlugQuery = {
  __typename?: "Query";
  tasteTestBySlug: {
    __typename?: "TasteTest";
    type: TasteTestType;
    policyId: string;
    creationTxHash: string;
    status: Status;
    slug: string;
    profile?: string | null;
    primaryColor?: string | null;
    secondaryColor?: string | null;
    banner?: string | null;
    banners: Array<string>;
    adaHandle: string;
    changeTVL24h: number;
    interactions: number;
    participants: number;
    asset: {
      __typename?: "Asset";
      assetId: string;
      policyId: string;
      assetName: string;
      ticker: string;
      totalSupply: string;
      decimals: number;
      logo: string;
      mintDate: { __typename?: "DateTime"; format: string };
    };
    parameters: {
      __typename?: "TasteTestParameters";
      penaltyAddress: string;
      foldFee: number;
      minUTXO: number;
      penaltyPercentage: number;
      poolPolicyId: string;
    };
    scripts: {
      __typename?: "TasteTestScripts";
      tasteTestPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tasteTestValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tasteTestStakeValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      collectFoldPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      collectFoldValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      rewardFoldPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      rewardFoldValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tokenHolderPolicy: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
      tokenHolderValidator: {
        __typename?: "ReferenceScript";
        scriptHash: string;
        utxo?: { __typename?: "TxOutRef"; txHash: string; index: number } | null;
      };
    };
    createdDate: { __typename?: "DateTime"; format: string };
    openDate: { __typename?: "DateTime"; format: string };
    lastCallDate: { __typename?: "DateTime"; format: string };
    endDate: { __typename?: "DateTime"; format: string; slot: string };
    currentBalance: {
      __typename?: "TokenStats";
      timestamp: { __typename?: "DateTime"; format: string };
      tokenSupplied: {
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      };
      tokenGathered: {
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      };
    };
    historicalBalance: {
      __typename?: "HistoricalBalance";
      times: Array<string>;
      tokenGathered: Array<string>;
    };
    projectDetails: {
      __typename?: "ProjectDetails";
      name: string;
      handle?: string | null;
      description: string;
      team: {
        __typename?: "Team";
        company: string;
        other: Array<string>;
        members: Array<{
          __typename?: "TeamMember";
          name: string;
          role: string;
          social?: { __typename?: "Social"; name: SocialType; url: string } | null;
        }>;
        socials: Array<{ __typename?: "Social"; name: SocialType; url: string }>;
      };
      socials: Array<{ __typename?: "Social"; name: SocialType; url: string }>;
      tokenomics: Array<{ __typename?: "PieSlice"; label: string; percentage: number }>;
      roadmap: Array<{
        __typename?: "Milestone";
        title: string;
        description: string;
        accomplished: boolean;
        dueDate: { __typename?: "DateTime"; format: string };
      }>;
      partners: Array<{
        __typename?: "Partner";
        logo: string;
        url: string;
        name: string;
        type: string;
      }>;
    };
    vestingSchedule: Array<{
      __typename?: "VestingParty";
      address: string;
      amount: string;
      label: string;
      releaseDate: { __typename?: "DateTime"; format: string };
    }>;
    fundingAllocations: Array<{ __typename?: "PieSlice"; label: string; percentage: number }>;
  };
};

export type GetTasteTestHistoryQueryVariables = Exact<{
  owner: Scalars["String"];
  tasteTest?: InputMaybe<Scalars["String"]>;
}>;

export type GetTasteTestHistoryQuery = {
  __typename?: "Query";
  history: Array<{
    __typename?: "Transaction";
    txHash: string;
    type: TransactionType;
    owner: string;
    createdAt: { __typename?: "DateTime"; format: string };
    totalCumulative: Array<{
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    }>;
    totalDelta: Array<{
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    }>;
    depositDelta: Array<{
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    }>;
    foldFeeDelta: Array<{
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    }>;
    lpDelta: Array<{
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    }>;
    minUTXODelta: Array<{
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    }>;
    depositCumulative: Array<{
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    }>;
    foldFeeCumulative: Array<{
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    }>;
    lpCumulative: Array<{
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    }>;
    minUTXOCumulative: Array<{
      __typename?: "TokenAmount";
      amount: string;
      asset: {
        __typename?: "Asset";
        assetId: string;
        policyId: string;
        assetName: string;
        ticker: string;
        totalSupply: string;
        decimals: number;
        logo: string;
        mintDate: { __typename?: "DateTime"; format: string };
      };
    }>;
  }>;
};

export type GetTasteTestTransactionsQueryVariables = Exact<{
  policyID: Scalars["String"];
}>;

export type GetTasteTestTransactionsQuery = {
  __typename?: "Query";
  tasteTest: {
    __typename?: "TasteTest";
    transactions: Array<{
      __typename?: "Transaction";
      txHash: string;
      type: TransactionType;
      owner: string;
      createdAt: { __typename?: "DateTime"; format: string };
      totalCumulative: Array<{
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      }>;
      totalDelta: Array<{
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      }>;
      depositDelta: Array<{
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      }>;
      foldFeeDelta: Array<{
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      }>;
      lpDelta: Array<{
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      }>;
      minUTXODelta: Array<{
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      }>;
      depositCumulative: Array<{
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      }>;
      foldFeeCumulative: Array<{
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      }>;
      lpCumulative: Array<{
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      }>;
      minUTXOCumulative: Array<{
        __typename?: "TokenAmount";
        amount: string;
        asset: {
          __typename?: "Asset";
          assetId: string;
          policyId: string;
          assetName: string;
          ticker: string;
          totalSupply: string;
          decimals: number;
          logo: string;
          mintDate: { __typename?: "DateTime"; format: string };
        };
      }>;
    }>;
  };
};

export type GetDepositUtxoMutationVariables = Exact<{
  tasteTest: Scalars["String"];
  owner: Scalars["String"];
}>;

export type GetDepositUtxoMutation = {
  __typename?: "Mutation";
  reserveForDeposit: { __typename?: "Node"; txHash: string; index: number };
};

export type GetUpdateUtxoMutationVariables = Exact<{
  tasteTest: Scalars["String"];
  owner: Scalars["String"];
}>;

export type GetUpdateUtxoMutation = {
  __typename?: "Mutation";
  reserveForUpdate: { __typename?: "Node"; txHash: string; index: number };
};

export type GetWithdrawalUtxoMutationVariables = Exact<{
  tasteTest: Scalars["String"];
  owner: Scalars["String"];
}>;

export type GetWithdrawalUtxoMutation = {
  __typename?: "Mutation";
  reserveForWithdrawal: Array<{ __typename?: "Node"; txHash: string; index: number }>;
};

export const AssetFragmentDoc = gql`
  fragment Asset on Asset {
    assetId
    policyId
    assetName
    ticker
    totalSupply
    decimals
    logo
    mintDate {
      format
    }
  }
`;
export const ReferenceScriptFragmentDoc = gql`
  fragment ReferenceScript on ReferenceScript {
    scriptHash
    utxo {
      txHash
      index
    }
  }
`;
export const TasteTestFragmentFragmentDoc = gql`
  fragment TasteTestFragment on TasteTest {
    policyId
    creationTxHash
    status
    slug
    profile
    primaryColor
    secondaryColor
    banner
    banners
    asset {
      ...Asset
    }
    adaHandle
    parameters {
      penaltyAddress
      foldFee
      minUTXO
      penaltyPercentage
      poolPolicyId
    }
    scripts {
      tasteTestPolicy {
        ...ReferenceScript
      }
      tasteTestValidator {
        ...ReferenceScript
      }
      tasteTestStakeValidator {
        ...ReferenceScript
      }
      collectFoldPolicy {
        ...ReferenceScript
      }
      collectFoldValidator {
        ...ReferenceScript
      }
      rewardFoldPolicy {
        ...ReferenceScript
      }
      rewardFoldValidator {
        ...ReferenceScript
      }
      tokenHolderPolicy {
        ...ReferenceScript
      }
      tokenHolderValidator {
        ...ReferenceScript
      }
    }
    createdDate {
      format
    }
    openDate {
      format
    }
    lastCallDate {
      format
    }
    endDate {
      format
      slot
    }
    changeTVL24h
    currentBalance {
      timestamp {
        format
      }
      tokenSupplied {
        asset {
          ...Asset
        }
        amount
      }
      tokenGathered {
        asset {
          ...Asset
        }
        amount
      }
    }
    historicalBalance {
      times
      tokenGathered
    }
    interactions
    participants
    projectDetails {
      name
      handle
      team {
        company
        members {
          name
          role
          social {
            name
            url
          }
        }
        other
        socials {
          name
          url
        }
      }
      description
      socials {
        name
        url
      }
      tokenomics {
        label
        percentage
      }
      roadmap {
        dueDate {
          format
        }
        title
        description
        accomplished
      }
      partners {
        logo
        url
        name
        type
      }
    }
    vestingSchedule {
      address
      amount
      releaseDate {
        format
      }
      label
    }
    fundingAllocations {
      label
      percentage
    }
  }
`;
export const TransactionFragmentDoc = gql`
  fragment Transaction on Transaction {
    txHash
    createdAt {
      format
    }
    type
    owner
    totalCumulative {
      asset {
        ...Asset
      }
      amount
    }
    totalDelta {
      asset {
        ...Asset
      }
      amount
    }
    depositDelta {
      asset {
        ...Asset
      }
      amount
    }
    foldFeeDelta {
      asset {
        ...Asset
      }
      amount
    }
    lpDelta {
      asset {
        ...Asset
      }
      amount
    }
    minUTXODelta {
      asset {
        ...Asset
      }
      amount
    }
    depositCumulative {
      asset {
        ...Asset
      }
      amount
    }
    foldFeeCumulative {
      asset {
        ...Asset
      }
      amount
    }
    lpCumulative {
      asset {
        ...Asset
      }
      amount
    }
    minUTXOCumulative {
      asset {
        ...Asset
      }
      amount
    }
  }
`;
export const GetTasteTestsDocument = gql`
  query getTasteTests {
    tasteTests {
      ...TasteTestFragment
    }
  }
  ${TasteTestFragmentFragmentDoc}
  ${AssetFragmentDoc}
  ${ReferenceScriptFragmentDoc}
`;
export const GetTasteTestByPolicyIdDocument = gql`
  query getTasteTestByPolicyId($policyID: String!) {
    tasteTest(policyID: $policyID) {
      type
      ...TasteTestFragment
    }
  }
  ${TasteTestFragmentFragmentDoc}
  ${AssetFragmentDoc}
  ${ReferenceScriptFragmentDoc}
`;
export const GetTasteTestBySlugDocument = gql`
  query getTasteTestBySlug($slug: String!) {
    tasteTestBySlug(slug: $slug) {
      type
      ...TasteTestFragment
    }
  }
  ${TasteTestFragmentFragmentDoc}
  ${AssetFragmentDoc}
  ${ReferenceScriptFragmentDoc}
`;
export const GetTasteTestHistoryDocument = gql`
  query getTasteTestHistory($owner: String!, $tasteTest: String) {
    history(owner: $owner, tasteTest: $tasteTest) {
      ...Transaction
    }
  }
  ${TransactionFragmentDoc}
  ${AssetFragmentDoc}
`;
export const GetTasteTestTransactionsDocument = gql`
  query getTasteTestTransactions($policyID: String!) {
    tasteTest(policyID: $policyID) {
      transactions {
        ...Transaction
      }
    }
  }
  ${TransactionFragmentDoc}
  ${AssetFragmentDoc}
`;
export const GetDepositUtxoDocument = gql`
  mutation getDepositUtxo($tasteTest: String!, $owner: String!) {
    reserveForDeposit(tasteTest: $tasteTest, owner: $owner) {
      txHash
      index
    }
  }
`;
export const GetUpdateUtxoDocument = gql`
  mutation getUpdateUtxo($tasteTest: String!, $owner: String!) {
    reserveForUpdate(tasteTest: $tasteTest, owner: $owner) {
      txHash
      index
    }
  }
`;
export const GetWithdrawalUtxoDocument = gql`
  mutation getWithdrawalUtxo($tasteTest: String!, $owner: String!) {
    reserveForWithdrawal(tasteTest: $tasteTest, owner: $owner) {
      txHash
      index
    }
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getTasteTests(
      variables?: GetTasteTestsQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<GetTasteTestsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetTasteTestsQuery>(GetTasteTestsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "getTasteTests",
        "query"
      );
    },
    getTasteTestByPolicyId(
      variables: GetTasteTestByPolicyIdQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<GetTasteTestByPolicyIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetTasteTestByPolicyIdQuery>(GetTasteTestByPolicyIdDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "getTasteTestByPolicyId",
        "query"
      );
    },
    getTasteTestBySlug(
      variables: GetTasteTestBySlugQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<GetTasteTestBySlugQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetTasteTestBySlugQuery>(GetTasteTestBySlugDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "getTasteTestBySlug",
        "query"
      );
    },
    getTasteTestHistory(
      variables: GetTasteTestHistoryQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<GetTasteTestHistoryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetTasteTestHistoryQuery>(GetTasteTestHistoryDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "getTasteTestHistory",
        "query"
      );
    },
    getTasteTestTransactions(
      variables: GetTasteTestTransactionsQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<GetTasteTestTransactionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetTasteTestTransactionsQuery>(
            GetTasteTestTransactionsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        "getTasteTestTransactions",
        "query"
      );
    },
    getDepositUtxo(
      variables: GetDepositUtxoMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<GetDepositUtxoMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetDepositUtxoMutation>(GetDepositUtxoDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "getDepositUtxo",
        "mutation"
      );
    },
    getUpdateUtxo(
      variables: GetUpdateUtxoMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<GetUpdateUtxoMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetUpdateUtxoMutation>(GetUpdateUtxoDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "getUpdateUtxo",
        "mutation"
      );
    },
    getWithdrawalUtxo(
      variables: GetWithdrawalUtxoMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<GetWithdrawalUtxoMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetWithdrawalUtxoMutation>(GetWithdrawalUtxoDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "getWithdrawalUtxo",
        "mutation"
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
